import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { LabelProperties } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface LabelPropertiesModel {
  labelPropertiesMap: Record<string, LabelProperties>;
  setLabelProperties: Action<LabelPropertiesModel, LabelProperties[]>;
  setLabelProperty: Action<LabelPropertiesModel, LabelProperties>;
  fetchLabelPropertiesLoading: boolean;
  setFetchLabelPropertiesLoading: Action<LabelPropertiesModel, boolean>;
  fetchLabelProperties: Thunk<LabelPropertiesModel, void, Injections, StoreModel, Promise<void>>;
  fetchLabelPropertiesFailure: Action<LabelPropertiesModel, ApplicationErrorOptions>;
}

export const labelPropertiesModel: LabelPropertiesModel = {
  labelPropertiesMap: {},
  setLabelProperties: action((state, labelProperties) => {
    const labelPropertiesMap = labelProperties.reduce<Record<string, LabelProperties>>((acc, curr) => {
      acc[curr.labelPropertiesId] = curr;
      return acc;
    }, {});
    state.labelPropertiesMap = labelPropertiesMap;
  }),
  setLabelProperty: action((state, labelProperty) => {
    state.labelPropertiesMap[labelProperty.labelPropertiesId] = labelProperty;
  }),
  fetchLabelPropertiesLoading: false,
  setFetchLabelPropertiesLoading: action((state, isLoading) => {
    state.fetchLabelPropertiesLoading = isLoading;
  }),
  fetchLabelProperties: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchLabelPropertiesLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchLabelProperties();
      actions.setLabelProperties(response);
      actions.setFetchLabelPropertiesLoading(false);
      return response;
    } catch (error) {
      actions.fetchLabelPropertiesFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchLabelPropertiesLoading(false);
      return error;
    }
  }),
  fetchLabelPropertiesFailure: action((state, error) => {
    console.error(error);
  }),
};

export default labelPropertiesModel;
